<div class="deactivate-modal">
  <div class="modal-header">
    <h2>De-activate Account</h2>
    <button
      mat-icon-button
      mat-dialog-close
      class="close-icon"
      aria-label="Close"
      (click)="close($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <h4>What this does:</h4>
    <ul>
      <li>Permanently decommissions your family portal profile.</li>
      <li>
        Deletes all personal data associated with your account from our
        database.
      </li>
      <li>Ends access to the portal and all related services.</li>
      <li>Automatically unsubscribes you from all future communications.</li>
    </ul>

    <p class="note">
      <strong>Note:</strong> Once deactivated, you will need to be re-registered
      by the Accenture employee to access the portal again.
    </p>

    <textarea
      [(ngModel)]="reason"
      placeholder="Mention the reason here"
    ></textarea>

    <button class="submit-button" (click)="submitDeactivation()">Submit</button>
  </div>
</div>
